var render, staticRenderFns
import script from "./DetailingNew.vue?vue&type=script&lang=js"
export * from "./DetailingNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports